// extracted by mini-css-extract-plugin
module.exports = {"content":"home_content__3C-PH","slider":"home_slider__3958d","upcoming":"home_upcoming__2rqFu","upcomingHeading":"home_upcomingHeading__JKOvo","retreats":"home_retreats__3HAeR"};